import { render, staticRenderFns } from "./SideBarContent.vue?vue&type=template&id=415b3e4a&"
import script from "./SideBarContent.vue?vue&type=script&lang=js&"
export * from "./SideBarContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports